import React from 'react';
import { getFooterLinks } from '../services/CmsService';

export default function FooterLinks() {
    const footerLinks = getFooterLinks();

    if (!footerLinks.length) {
        return null;
    }

    return (
        <footer className="footer-links">
            {footerLinks.map((footerLink, index) => (
                <a
                    key={`${footerLink.Title}-${index}`}
                    className="footer-links__link"
                    href={footerLink.Link}
                    target="_blank"
                    rel="noopener noreferrer">
                    {footerLink.Title}
                </a>
            ))}
        </footer>
    );
}
